import axios from "axios";

export const getTerritoryCountries = callback => {
  var promise = axios({
    method: "get",
    url: "/api/territory_countries"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
